import { render, staticRenderFns } from "./editAccount.vue?vue&type=template&id=46f82982&scoped=true"
import script from "./editAccount.vue?vue&type=script&lang=ts"
export * from "./editAccount.vue?vue&type=script&lang=ts"
import style0 from "./editAccount.vue?vue&type=style&index=0&id=46f82982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f82982",
  null
  
)

export default component.exports